import {ProfileRepository} from "@web-libs/features/profile/domain/profile.repository";
import {HttpConcern} from "@web-libs/core/http/infrastructure/client-side/use-http.concern";
import {
    createPasswordDTO,
    createProfileDTO,
    parseProfileDTO,
    ProfileDTO
} from "@web-libs/features/profile/api/dto/profile-dto.types";
import {Profile} from "@web-libs/features/profile/domain/profile.types";
import {resolveAfter} from "@web-libs/util/promises/promises";



export const createProfileRepository = (http: HttpConcern): ProfileRepository =>{


    const getProfile = async () => {
        return await http.get<ProfileDTO>('/users/self').then(
            (response) => {
              return  parseProfileDTO(response);
            }
        )
    }

    const updateProfile = async (profile: Profile) => {
        return await http.put('/users/me', createProfileDTO(profile)).then(
            () => {
                return profile;
            }
        )
    }


    const resetPassword = async (_oldPassword: string, _newPassword: string): Promise<boolean> => {
        return await http.put(`/users/me/password`, "", { skipLang: true, queryParams: {currentPassword: _oldPassword, newPassword: _newPassword}}).then(
            () => {
                return true;
            }
        )
    }



    return {
        getProfile,
        updateProfile,
        resetPassword
    }

}
